import React, { useEffect, useState, useRef } from 'react';
import io from "socket.io-client";
import Peer from "simple-peer";
import '../../App.css';
import {ENDPOINT} from '../../utils/Constants.js';

//open a server connection
let socket

const WebRTC =(props) => {
  //States

  let {name,room,role}=props
  //console.log("Props:",props)
  //console.log("Leave?",leave)
  let [usersInRoom,setUsersInRoom]=useState([])
  let [me,setMe]=useState()//socketID & username of this user {id: ,name: }
  let [myStream,setMyStream] = useState()
  let [partner,setPartner] = useState()//socketID & username of other person in call
  let [partnerStream,setPartnerStream] = useState()

  //let [callAccepted,setCallAccepted] = useState(false)//has the call started?
  let [callStatus,setCallStatus]=useState(false) //true while call is ongoing, otherwise false
  let [receivingCall,setReceivingCall] = useState(false)//am I receiving a call?
  //let [,set] = useState()

  //References
  const myVideo = useRef() //reference for own html video tag
  const partnerVideo = useRef() //reference for partner's html video tag
  const connection = useRef() //allows to disconnect the call

  useEffect(()=>{

    console.log(name,"in", room);
    socket = io(ENDPOINT);
    //ask user to allow access to camera & mic
    navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((webCamStream) => {
      setMyStream(webCamStream); //pass to state of stream
      if (myVideo.current) {
          myVideo.current.srcObject = webCamStream; //or MyStream?
          //myStream.current = stream
      }
    })
    //join the VideoChat
    socket.emit('join', {name, room}, (error)=>{
    console.log("Joining the room for video calls")
        if(error) {
            console.log(error);
        }
    });

    //on joining, receive own socketID & userName...
    socket.on('me', (data)=>{
      console.log("Just received my socket id:",data.id)
      setMe(data)
    })

    //...and all user data in the same room
    socket.on("roomData", ({users}) =>{
      setUsersInRoom(users.filter((user)=>user.name !== name.toLowerCase())) //should only be one.
      console.log("Just received all current users in this room:",usersInRoom)
    });
    //when someone else is calling
    socket.on("callUser", (data)=>{
      console.log(data.name," is calling you.")
      setPartner({id:data.from, name:data.name})
      setPartnerStream(data.signal)
      setReceivingCall(true)
    })
    //if the other user ends the call
    socket.on("callEnded",(data)=>{
      resetCall()
      setUsersInRoom(data.users.filter((user)=>user.name !== name.toLowerCase()))
      console.log(data.text,"I'm resetting everything.")
    })
  },[]);

  function callPeer(user){
    //create WebRTC Peer object
    console.log("Calling...")
    const peer = new Peer({
      initiator: true, //we're initiating the call
      trickle: false,
      stream: myStream //pass the state myStream with our own cam&mic stream
    })
    //what info to send to the user we're calling
    peer.on("signal", (data) => {
      socket.emit("callUser", {
        to: user.id, //id of the user we want to call, passed from function props
        signal: data,
        from: me.id,
        name: me.name})  //chnge from yourID to
    })
    //to cancel connection later on
    connection.current = peer
    //this is the incoming video stream from the another user
    peer.on("stream", (incomingStream) => {
      if (partnerVideo.current) {
          partnerVideo.current.srcObject = incomingStream;
      }
    });

    socket.on("callAccepted", (signal) => {
      setPartner(user)
      //setCallAccepted(true)
      setCallStatus(true)
      console.log("Call has been accepted. Have a nice chat.")
      //use partner's signal as our incoming signal
      peer.signal(signal);

    })
  }

  function answerCall(){
    console.log("Accepting the call...")
    //setCallAccepted(true)
    setCallStatus(true)
    //create WebRTC Peer object
    const peer = new Peer({
      initiator: false, //we're receiving the call
      trickle: false,
      stream: myStream //pass the state myStream with our own cam&mic stream
    })
    connection.current = peer

    peer.on("signal", (data) => {
      socket.emit("answerCall", {
        to: partner.id, //id of the user whose call we accept
        signal: data})  //chnge from yourID to
    })
    //this is the incoming video stream from the another user
    peer.on("stream", (incomingStream) => {
      if (partnerVideo.current) {
          partnerVideo.current.srcObject = incomingStream;
      }
    });
    //use partner's signal as our incoming signal
    peer.signal(partnerStream)

  }
  function resetCall(){
    setCallStatus(false)
    //setCallAccepted(false)
    setReceivingCall(false)
    setPartner({})
    setPartnerStream()
    /*if (connection.current){
      connection.current.destroy()
    }*/
  }
  function endCall(){
    if (partner){
      socket.emit("endCall",{
        to:partner.id,
        from:me.id,
        name:me.name,
        room: room
      })
    }
    resetCall()
    console.log("The call has ended, I'm resetting everything.")
  }

  useEffect(()=>{
    if (props.leave){
    //close the server connection when user leaves the page
    console.log("Leaving the chat page:")
    endCall()
    socket.disconnect(true)
    console.log("...and disconnected from server.")
    props.onLeave(props.nextPage)
  }

  },[props.leave])

  return(
    <div className="container-vid">
      <div className="row">
        <div className="column-item">
          {callStatus?
            partnerVideo?
              <video playsInline ref={partnerVideo} autoPlay />
            :
              <p className="vid-info">No video received from the other user.</p>
          :
            receivingCall?
              <div>
                <p className="vid-info">{ partner.name } is calling you, please click the button below to start chatting</p>
                <div id="labelBtn">
                        <button className="textButton green" onClick={answerCall}>Start Video Chat</button>
                </div>
              </div>
            :
              <p className="vid-info">The call hasn't started.</p>}
        </div>
        <div className="column-item">
          {myStream? <video controls playsInline muted ref={myVideo} autoPlay />
          :<p className="vid-info">No camera detected or no permission to use your camera.</p>
          }
        </div>
      </div>
      <div className="row">
        {//call button logic
        role===1? //if we're a wizard
          callStatus? //if we're in a call:
          <button
            className="textButton red"
            onClick={endCall}>End Call
          </button>
        ://if we're not in a call
          usersInRoom.map(
            (user,idx)=>(
              <button
                key={"call_"+idx}
                className="textButton green"
                onClick={()=>callPeer(user)}>Call user {user.name}
              </button>
            )
        )
        :null
        }
      </div>
    </div>
  )
}

export default WebRTC;
